export const PROJECTS = [
    {
      title: "AI Flashcards - an AI-powered Flashcard Generator",
      description: "AI Flashcards is a full-stack web application that lets users create study flashcards manually or generate them automatically using AI. Users can type in a topic, and the app generates multiple flashcards with questions and answers, perfect for studying or reviewing concepts. The app features an intuitive interface, card flip animations, and the ability to delete individual flashcards.  Frontend built with React, React-Bootstrap, and CSS.  Backend built using Node.js and Express.js and uses an OpenAI API for card generation.",
      technologies: ["nodejs", "javascript", "npm", "chrome", "react", "reactbootstrap", "css3", "git", "github", "html5", "homebrew", "vscode", "OpenAI", "Render", "Axios"],
      page: "https://ai-flashcards-mzbm.onrender.com/",
      github: "https://github.com/philipdemand/ai-flashcards",
      alt: "AI-Flashcards",
      image: {
        width: 0,
        height: 10,
        url: '/flashcardPNG.001.png'
      }
    },
    {
      title: "Gig-Board - A Gig-Finder for Musicians",
      description: "An app where musicians can find and apply for gigs, and where holders of gigs can find musicians.  Frontend built with React.  Backend built with Ruby On Rails using a PostgreSQL database, bcrypt for password-hashing, and delegated types to distinguish user-types: musicians and directors. Styled using React Bootstrap",
      technologies: ["nodejs", "javascript", "npm", "chrome", "ruby", "rails", "react", "reactrouter", "reactbootstrap", "css3", "git", "github", "postman", "html5", "postgresql", "homebrew", "vscode"],
      page: "https://gig-board.onrender.com",
      github: "https://github.com/philipdemand/gig-board-app",
      alt: "gig-board",
      image: {
        width: 2880,
        height: 1644,
        url: '/gig-board.png'
      }
    },
    {
      title: "Personal Website",
      description: "My portfolio website! Built using React and CSS3. Serverless function setup to accept HTTP requests from the contact form and send an email using EmailJS. The website is fully responsive using React Bootstrap. Deployed using AWS",
      technologies: ["reactbootstrap", "chrome", "css3", "devicon", "git", "github", "html5", "javascript", "nodejs", "npm", "react", "homebrew", "vscode", "amazonwebservices"],
      page: null,
      github: "https://github.com/philipdemand/my-personal-website",
      alt: "personal-website",
      image: {
        width: 2880,
        height: 1800,
        url: '/my-personal-website.png'
      },
    }
  ];